module.exports = __webpack_public_path__ + "static/picmain-642a4c035d4b28b378130cf1f6ec0aa1.png";